export const styles = theme => ({
  btnRoot: {
    color: "inherit",
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    fontSize: "0.8rem",
    justifyContent: "left",
    width: "100%",
    fontWeight: 500,
    lineHeight: 1.75,
    borderRadius: "4px",
    textTransform: "uppercase",
    color: "rgba(0, 0, 0, 0.87)",
    backgroundColor: "#ffffff"
  },
  calendarIcon: {
    marginRight: theme.spacing(1)
  }
});
